import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ProtectedRoute = ({ children }) => {
    const { cookie } = useAuth();
    const isAuthenticated = cookie?.user?.auth === 'verified' && ['admin'].includes(cookie?.user?.role);

    if (!isAuthenticated) {
        // user is not authenticated
        return <Navigate to="/login" />;
    }
    return children;
};

export default ProtectedRoute;
